import {
    CREATE_USER,
    INCREASE_NUMBER_OF_USERS,
    DECREASE_NUMBER_OF_USERS,
    SET_NUMBER_OF_USERS, SET_CONTENT_PROVIDER,
} from "../actions";

const user = (state = [], action) => {
    switch (action.type) {
    case CREATE_USER:
        return {
            id: action.id,
            userType: action.userType,
            minNumberOfUsers: action.minNumberOfUsers,
            maxNumberOfUsers: action.maxNumberOfUsers,
            numberOfUsers: action.numberOfUsers,
            amountPerUser: action.amountPerUser,
            name: action.name,
            unit: action.unit,
            dependency: action.dependency,
            contentProviders: action.contentProviders,
            chosenProvider: '',
        };
    case SET_CONTENT_PROVIDER:
        return (state.userType === action.userType)
            ? { ...state, chosenProvider: action.chosenProvider }
            : state;
    case SET_NUMBER_OF_USERS:
        return (state.userType === action.userType)
            ? { ...state, numberOfUsers: action.numberOfUsers }
            : state;
    case INCREASE_NUMBER_OF_USERS:
    case DECREASE_NUMBER_OF_USERS:
        return (state.userType === action.userType)
            ? { ...state, numberOfUsers: action.numberOfUsers }
            : state;
    default:
        return state
    }
}

const users = (state = [], action) => {
    switch (action.type) {
    case CREATE_USER:
        if (state.some(_user => _user.userType === action.userType)) {
            return state;
        }

        return [
            ...state,
            user(undefined, action)
        ];
    case SET_NUMBER_OF_USERS:
    case SET_CONTENT_PROVIDER:
    case INCREASE_NUMBER_OF_USERS:
    case DECREASE_NUMBER_OF_USERS:
        return state.map((_user) => user(_user, action));
    default:
        return state;
    }
};

export default users;
